<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Vedanta Gurukul Academy</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <span>Vedanta Gurukul Academy</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- class area start here -->
        <section class="bd-class-area pt-110 pb-70">
            <div class="container">
                <div class="row">

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="bd-class-3 fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/activities/a1.png" alt="class image not found!">
                            </div>
                            <div class="bd-class-content-3 theme-bg-6 ">
                                <h3 class="bd-class-title-3"><a href="competitive_exams.html">Competitive Exams</a></h3>
                                <p class="mb-20">An Academy for IIT-JEE, NEET, KVPY, OLYMPIAD training</p>
                            </div>
                            <div class="bd-class-btn-3 theme-bg-2 text-center">
                                <a href="competitive_exams.html">Know More</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="bd-class-3 fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/activities/a3.png" alt="class image not found!">
                            </div>
                            <div class="bd-class-content-3 theme-bg-6 ">
                                <h3 class="bd-class-title-3"><a href="ca_foundation.html">CA Foundation </a></h3>
                                <p class="mb-20">Introducing tutoring for CA Foundation in collaboration with Anil
                                    Sharma Classes.</p>

                            </div>
                            <div class="bd-class-btn-3 theme-bg-2 text-center">
                                <a href="ca_foundation.html">Know More</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- class area end here -->

        <!-- testimonial area start here  -->
        <section class="bd-testimonial-area-2 pb-120 p-relative pt-120 theme-bg">
            <div class="bd-testimonial-bottom-shape">
                <img src="/img/shape/wave-section-break.png" alt="img not found!">
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper is-white z-index-1 p-relative text-center mb-55 wow fadeInUp"
                            data-wow-duration="1s" data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Testimonials</h2>
                            <p>Discover the voice of satisfied families and their experience at VGPS</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="bd-testimonial-active-2 swiper-container wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="bd-testimonial-2 mr-5 theme-bg-6 mb-25">
                                        <div class="bd-testimonial-rating mb-30">
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                        </div>
                                        <div class="bd-testimonial-content-2 mb-35">
                                            <p>VGPS prepared me not just academically, but also for life beyond the
                                                classroom. I feel confident and ready for whatever comes my way.</p>
                                        </div>
                                        <div class="bd-testimonial-avatar d-flex align-items-center">
                                            <div class="bd-testimonial-avatar-thumb">
                                                <img src="/img/activities/testimonial/1.png"
                                                    alt="testimonial avatar">
                                            </div>
                                            <h6 class="bd-testimonial-avatar-title-2 mb-0">Abhay Sharma</h6>
                                            <span>Class XI Bio</span>
                                            <div class="bd-testimonial-quote d-none d-sm-block clr-2">
                                                <i class="flaticon-quote"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="bd-testimonial-2 mr-5 clr-3 theme-bg-7">
                                        <div class="bd-testimonial-rating mb-30">
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                        </div>
                                        <div class="bd-testimonial-content-2 mb-35">
                                            <p>The opportunities for hands-on learning are abundant. From labs to field
                                                trips, VGPS truly makes education come alive</p>
                                        </div>
                                        <div class="bd-testimonial-avatar d-flex align-items-center">
                                            <div class="bd-testimonial-avatar-thumb">
                                                <img src="/img/activities/testimonial/2.png"
                                                    alt="testimonial avatar">
                                            </div>
                                            <h6 class="bd-testimonial-avatar-title-2 mb-0">Yashaswi Goyal</h6>
                                            <span>Class X </span>
                                            <div class="bd-testimonial-quote d-none d-sm-block clr-1">
                                                <i class="flaticon-quote"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- slider dots pagination -->
                        <div class="bd-testimonial-pagination-2 bd-dots-pagination justify-content-center wow fadeInUp"
                            data-wow-duration="1s" data-wow-delay=".3s"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- testimonial area end here  -->

    </main>
</template>
<script>
export default {
    name: "AcademyView",
};
</script>
